module.exports = __webpack_public_path__ + "fc92d8c94d4f584f617eaa373c49799f.pdf";